const KL_CAROUSEL_CLONES_SELECTOR = '[data-kl-carousel-clones]';
const KL_CAROUSEL_CLONES_STRIP_ATTRIBUTE = 'data-kl-carousel-clones-strip';
const KL_CAROUSEL_CLONES_READY_ATTRIBUTE = 'data-kl-carousel-clone-ready';
const KL_CAROUSEL_CLONES_CONTENT_EVENT = 'kl:content:added';

const KL_CAROUSEL_CLONE_SELECTOR = '.splide__slide--clone';

const KL_CAROUSEL_CLONES_ID_REFERENCE_ATTRIBUTES = [
  'for',
  'form',
  'list',
  'aria-controls',
  'aria-labelledby',
  'aria-describedby',
  'aria-owns',
];

function getCloneAttributesToStrip(carouselElement) {
  const value = carouselElement.getAttribute(KL_CAROUSEL_CLONES_STRIP_ATTRIBUTE);

  if (!value) return [];

  return value
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean);
}

function stripCloneAttributes(cloneElement, attributeNames) {
  if (!attributeNames.length) return;

  [cloneElement, ...cloneElement.querySelectorAll('*')].forEach((element) => {
    attributeNames.forEach((attributeName) => element.removeAttribute(attributeName));
  });
}

function makeCloneIdsUnique(cloneElement, cloneIndex) {
  const idMap = new Map();

  cloneElement.querySelectorAll('[id]').forEach((element) => {
    const nextId = `${element.id}--kl-clone-${cloneIndex}`;

    idMap.set(element.id, nextId);
    element.id = nextId;
  });

  if (!idMap.size) return;

  [cloneElement, ...cloneElement.querySelectorAll('*')].forEach((element) => {
    KL_CAROUSEL_CLONES_ID_REFERENCE_ATTRIBUTES.forEach((attributeName) => {
      const value = element.getAttribute(attributeName);

      if (!value) return;

      const nextValue = value
        .split(/\s+/)
        .map((token) => idMap.get(token) || token)
        .join(' ');

      if (nextValue !== value) element.setAttribute(attributeName, nextValue);
    });
  });
}

function prepareClones(carouselElement, cloneCounter) {
  const clones = carouselElement.querySelectorAll(
    `${KL_CAROUSEL_CLONE_SELECTOR}:not([${KL_CAROUSEL_CLONES_READY_ATTRIBUTE}])`
  );

  if (!clones.length) return 0;

  const attributeNames = getCloneAttributesToStrip(carouselElement);

  clones.forEach((clone, index) => {
    clone.setAttribute(KL_CAROUSEL_CLONES_READY_ATTRIBUTE, '');
    stripCloneAttributes(clone, attributeNames);
    makeCloneIdsUnique(clone, cloneCounter + index);
  });

  return clones.length;
}

function announceClones(carouselElement) {
  try {
    document.dispatchEvent(
      new CustomEvent(KL_CAROUSEL_CLONES_CONTENT_EVENT, { detail: { root: carouselElement } })
    );
  } catch (error) {
    console.debug('kl-carousel-clones: the copies could not be announced', { error });
  }
}

function initCarouselClones(carouselElement) {
  if (carouselElement.dataset.klCarouselClonesReady === 'true') return;

  carouselElement.dataset.klCarouselClonesReady = 'true';

  let cloneCounter = 0;

  function handleClones() {
    const preparedCount = prepareClones(carouselElement, cloneCounter);

    if (!preparedCount) return;

    cloneCounter += preparedCount;
    announceClones(carouselElement);
  }

  try {
    new MutationObserver(handleClones).observe(carouselElement, { childList: true, subtree: true });
  } catch (error) {
    console.debug('kl-carousel-clones: the row could not be watched for copies', { error });
  }

  handleClones();
}

function initCarouselClonesWithin(rootElement) {
  rootElement.querySelectorAll(KL_CAROUSEL_CLONES_SELECTOR).forEach(initCarouselClones);
}

initCarouselClonesWithin(document);

document.addEventListener('shopify:section:load', (event) => {
  initCarouselClonesWithin(event.target);
});

document.addEventListener(KL_CAROUSEL_CLONES_CONTENT_EVENT, (event) => {
  const injectedRoot = event.detail && event.detail.root;

  if (!injectedRoot || typeof injectedRoot.querySelectorAll !== 'function') return;

  initCarouselClonesWithin(injectedRoot);
});
